import type { AxiosResponse } from 'axios';

/** Reads the total row count from the X-Total-Count header, with sensible fallbacks. */
export function extractTotal(response: AxiosResponse): number {
  const raw = response.headers?.['x-total-count'];
  const headerCount = parseInt(typeof raw === 'string' ? raw : String(raw ?? ''), 10);
  if (!Number.isNaN(headerCount) && headerCount >= 0) return headerCount;
  const data = response.data;
  if (Array.isArray(data)) return data.length;
  return 0;
}

/** Rows are plain JSON arrays from the analytics endpoints. */
export function extractRows<T>(response: AxiosResponse): T[] {
  return Array.isArray(response.data) ? (response.data as T[]) : [];
}

/** ISO-8601 instant string for the backend from/to params, or null when unset. */
export function toIsoOrNull(date: Date | null): string | null {
  if (!date || Number.isNaN(date.getTime())) return null;
  return date.toISOString();
}

export function formatTimestamp(value: string | null): string {
  if (!value) return '-';
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? value : d.toLocaleString();
}

export function formatDuration(ms: number | null): string {
  if (ms === null || ms === undefined) return '-';
  return `${Math.round(ms)} ms`;
}
